import React from 'react';
import Step from './Step';
import Login from '../hooks/useLogin';
import BmiCookieConsent from './BmiCookieConsent';
import { CreateDotaznik } from '../hooks/createDotaznik';
import stepsJson from '../assets/steps.json';
import dotaznikJson from '../assets/dotaznik.json';
import BG_IMG_CLOUDS from "../assets/img/bg_img_clouds.png";
import BG_IMG_PLANE from "../assets/img/bg_img_plane.png";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBSwitch,
    MDBBtn,
    MDBValidationItem,
    MDBAccordion,
    MDBAccordionItem,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';



const CONSTANTS = {
    FIRST_PAGE_SWITCH_TEXT_CLASSES: "d-grid align-items-end px-3 mb-4 mt-3 user-select-none pointer switch-text",
}



class PriceCalculatorForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            files: [],
            dotaznik: dotaznikJson,
            dotaznikValid: false,
            dotaznikCreated: false,

            roofCalculation: true,
            isolation: false,
            documentation: false,
            noDocumentation: false,
            buildingExists: false,
            extensions: false,
            gdprConsent: false,

            steps: stepsJson,
            activeItems: [3, 7],
            activeStep: 1,

            selectedCoveringColor: "cerna",

            noDocumentationModal: false,
            noBuildingModal: false,
            gdprModal: false,
            confirmationModal: false,
            loadingModal: false,
            loadingModalTitle: "Požiadavka na vápočet sa odosiela . . .",
            loadingModalText: "",

            config: {},
        };
        this.stateHandler = this.stateHandler.bind(this);
        this.dotaznikCreateHandler = this.dotaznikCreateHandler.bind(this);
    }

    componentDidMount() {
        // Relative on purpose: on prod the site root serves the CZ build's config.json
        fetch('config.json')
            .then(r => r.json())
            .then(config => this.setState({ config }))
            .catch(() => {});
    }

    handleDocumentation(e) {
        if (e.target.id === "HaveDocumentation" && e.target.checked) {
            if (this.state.noDocumentation) {
                document.getElementById('DontHaveDocumentation').click();
            }
        } else if (e.target.id === "DontHaveDocumentation" && e.target.checked) {
            if (this.state.documentation) {
                document.getElementById('HaveDocumentation').click();
            }
        } else if (e.target.id === "DontHaveDocumentation" && !e.target.checked) {
            this.setState({ buildingExists: false })
        }
        let stepContact = this.getStep(7);
        stepContact.showMap = this.state.noDocumentation;
    }

    stepsControl() {
        let stepsArray = this.state.steps;
        stepsArray.forEach(step => {
            if (step.state != "") {
                let value = this.state[step.state];
                step.visible = value;
            }
            if (step.number == 7) {
                step.showMap = this.state.noDocumentation;
            }
            step.visibleClass = (step.visible) ? "" : "d-none";
        })
    }

    stateHandler(name, value) {
        if (name === 'extensions') {
            this.setState({ ...this.state, [name]: value }, () => this.accordionHandler([3, 4]));
        } else if (name === 'isolation') {
            this.setState({ ...this.state, [name]: value });
        } else {
            this.setState({ ...this.state, [name]: value });
        }
    }

    toggleNoDocModal() {
        if (this.state.noDocumentation) {
            this.setState({ noDocumentationModal: !this.state.noDocumentationModal });
        }
    }

    toggleNoBuildingModal() {
        this.setState({ noBuildingModal: !this.state.noBuildingModal });
    }
    toggleConfirmationModal() {
        this.setState({ confirmationModal: !this.state.confirmationModal });
    }

    accordionHandler(id) {
        this.setState({ ...this.state, activeItems: id });
    }


    disableSendButton(setDisabled) {
        let sendButton = document.getElementById('sendFormBtn');
        if (sendButton) {
            (setDisabled) ? sendButton.setAttribute('disabled', true) : sendButton.removeAttribute('disabled');
        }
    }

    fillDotaznik() {
        this.disableSendButton(true);

        let step2 = this.getStep(2); // project doc
        let step3 = this.getStep(3); // coverings
        let extensions = this.getStep(4).data.values; // extensions
        let step5 = this.getStep(5); // gutters
        let step6 = this.getStep(6); // isolation
        let step7 = this.getStep(7); // contact form [objectPhoto for fileUpload]
        if (!this.state.extensions) extensions = {};

        //var dotaznik = this.state.dotaznik;
        var dotaznik = dotaznikJson;
        dotaznik.dokumentace = this.state.documentation
        //dotaznik.poznamka = step2.data.filesNote || "";
        dotaznik.datum = this.getCurrentDate();
        dotaznik.kontakt = step7.data.formData.kontakt;
        if (dotaznik.kontakt.typZadavatele === "Obchodník") {
            dotaznik.kontakt = { ...dotaznik.kontakt, obec: "", psc: "", ulice: "" };
        } else {
            dotaznik.kontakt = { ...dotaznik.kontakt, okres: "", stavebniny: "" };
        }
        dotaznik.stavba = step7.data.formData.stavba;
        if (dotaznik.stavba.investor == "") {
            dotaznik.stavba.investor = dotaznik.kontakt.jmeno + " " + dotaznik.kontakt.prijmeni;
        }
        dotaznik.poznamka = step7.data.formData.stavba.poznamka;

        if (this.state.roofCalculation) {
            dotaznik.sortiment = {
                stdKrytina: step3.data.popularOnly,
                krytiny: step3.data.dotaznikCoverings,
                okapTyp: step5.data.chosenOkap.model,
                okapBarva: step5.data.chosenOkap.barva,
                rozsireni: {
                    protisnehovyHak: (extensions.item24) ? "A" : "N" || "N",
                    lemovani: (extensions.item21) ? "A" : "N" || "N",
                    okno: extensions.item14 || 0,
                    plosina40: extensions.item15 || 0,
                    kanalizace: extensions.item17 || 0,
                    sanita: extensions.item18 || 0,
                    antena: extensions.item19 || 0,
                    turbokotel: extensions.item20 || 0,
                    luminex44: extensions.item22 || 0,
                    luminex60: extensions.item23 || 0,
                }
            }
        }
        if (this.state.isolation) {
            dotaznik.izolace = { ...step6.data };
            dotaznik.izolace.izolaceTloustka = dotaznik.izolace.izolaceTyp + " " + dotaznik.izolace.izolaceTloustka;
            if (!dotaznik.izolace.rozpisPrvku) dotaznik.izolace.zatepleniPresahu = dotaznik.izolace.rozpisPrvku;
        }
        //console.log("dotaznik to send", dotaznik)

        // Files
        let docFiles = [];
        if (step2.data.files != null) {
            docFiles = docFiles.concat([...step2.data.files]);
            dotaznik.bramac.zdroj = '016';
        }
        if (step7.data.objectImage != undefined) {
            let objectImages = [...step7.data.objectImage];
            objectImages.forEach(file => { file.typ = 'GPS'; });
            docFiles = docFiles.concat(objectImages);
        }

        // Set files, then create Dotaznik
        this.setState({ files: docFiles },
            () => this.setState({ dotaznikValid: true },
                () => this.setState({ loadingModal: true }))
        );

    }
    sendDotaznik() {
        return ((this.state.dotaznikValid) ?
            <CreateDotaznik state={this.state} handler={this.dotaznikCreateHandler} />
            : <div></div>
        )
    }

    //callback function after create dotaznik API
    dotaznikCreateHandler(isCreated, message, responseMessage) {
        if (isCreated) {
            this.setState({ dotaznikCreated: true },
                () => this.setState({ loadingModalTitle: "Požiadavka na výpočet bola úspešne odoslaná" },
                    () => this.setState({ loadingModalText: "Počkajte prosím na presmerovanie" })
                )
            );
            return;
        }
        this.disableSendButton(false);
        if (message == "notAuth" || (responseMessage.error != undefined && responseMessage.error == "Unauthorized")) {
            this.showInvalid("ErrorCreate", "Nepodarilo sa spojiť so servrom");
        } else if (typeof responseMessage === "string" && responseMessage.slice(0, 18) == "Nelze přiřadit PSČ") {
            this.showInvalid("pscKontakt", "Chyba vo formulári - neplatné PSČ odosielateľa. Zadajte iné najbližšie PSČ.");
        } else {
            this.showInvalid("ErrorCreate", "Nepodarilo sa odoslať formulár");
        }

        this.setState({ dotaznikValid: false },
            () => this.setState({ loadingModal: false })
        );
    }

    getCurrentDate() {
        var currentdate = new Date();
        var datetime = currentdate.getFullYear() + '-'
            + (((currentdate.getMonth() + 1) < 10) ? "0" : "") + (currentdate.getMonth() + 1) + '-'
            + ((currentdate.getDate() < 10) ? "0" : "") + currentdate.getDate() + "T"
            + ((currentdate.getHours() < 10) ? "0" : "") + currentdate.getHours() + ":"
            + ((currentdate.getMinutes() < 10) ? "0" : "") + currentdate.getMinutes() + ":"
            + ((currentdate.getSeconds() < 10) ? "0" : "") + currentdate.getSeconds();
        return datetime;
    }



    validateAll() {
        // if dotaznik was already created by API then ignore validation
        if (this.state.dotaznikCreated) {
            this.showInvalid('alreadyCreated', 'Formulár už bol vytvorený, nie je potrebné ho znovu posielať');
            return;
        }
        // 1 or 2 switch, 3 or 4(ano/yes) switch
        if (!this.state.roofCalculation && !this.state.isolation) {
            this.showInvalid("RoofCalculation", "Vyberte aspoň jednu z možností kalkulácie - strešnú krytinu a/alebo nadkrokvovú izoláciu");
            return;
        }
        if (!this.state.documentation && !this.state.noDocumentation) {
            this.showInvalid("HaveDocumentation",
                "Vyberte jednu z možností dokumentácie - buď máte projektovú dokumentáciu alebo máte existujúci objekt");
            return;
        }

        // has documentation valid
        if (this.state.documentation) {
            let docStep = this.getStep(2);
            if (docStep.data.files == undefined || docStep.data.fileSize == 0) {
                this.showInvalid("documentationFiles", "Nahrajte súbory dokumentácie");
                return;
            } else if (docStep.data.fileSize >= 20000000) {
                this.showInvalid("documentationFiles", "Príliš veľké súbory, vyberte menej súborov");
                return;
            }
        }

        // selected coverings
        if (this.state.roofCalculation) {
            let coveringStep = this.getStep(3);
            if (coveringStep.data == undefined
                || coveringStep.data.dotaznikCoverings == undefined
                || coveringStep.data.dotaznikCoverings.length == 0) {
                this.setState(
                    { ...this.state, activeItems: [3] },
                    () => this.showInvalid("popularCovering", "Vyberte aspoň jeden model strešnej krytiny")
                );
                return;
            }
        }

        // isolation type and width
        if (this.state.isolation) {
            let isolationStep = this.getStep(6);
            if (isolationStep.data.izolaceTyp == "" || isolationStep.data.izolaceTloustka == "" ||
                isolationStep.data.izolaceTloustka <= 0 ||
                isolationStep.data == undefined || Object.keys(isolationStep.data).length < 1) {
                this.setState(
                    { ...this.state, activeItems: [6] },
                    () => this.showInvalid("isolationWidth", "Vyberte typ a hrúbku izolácie")
                );
                return;
            }

            // 'Rozpis prvku' or 'Servisni posouzeni' atleast
            if (!isolationStep.data.rozpisPrvku && !isolationStep.data.servisniPosouzeniTepelneOchrany) {
                this.setState(
                    { ...this.state, activeItems: [6] },
                    () => this.showInvalid("rozpisPrvku", "Vyberte aspoň jednu z možnosti \n 'Rozpis prvků' nebo 'Servisní posouzení'")
                );
                return;
            }

            // isolation servis validation
            if (isolationStep.data.servisniPosouzeniTepelneOchrany == true) {
                if (isolationStep.data.osovaRoztecKrokvi == "") {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("roofCompPitch", "Zadajte hodnotu")
                    );
                    return;
                }
                if (isolationStep.data.sirkaKrokvi == "") {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("roofCompWidth", "Zadajte hodnotu")
                    );
                    return;
                }
                if (isolationStep.data.konstrukcniVrstvy.find(row => row.nazev != "") == undefined) {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("nazev", "Musia byť vyplnené konštručné vrstvy strechy")
                    );
                    return;
                }
            }
        }

        // contact form
        this.setState({ activeItems: [7] });
        // map address input
        if (this.state.noDocumentation) {
            let addressInput = document.querySelector('div#mapAutocompleteDiv .geocoder-container input');
            if (addressInput && (addressInput.value === undefined || addressInput.value === "")) {
                addressInput.setCustomValidity("Vyberte platnú adresu stavby");
                addressInput.reportValidity();
                addressInput.setCustomValidity("");
                return;
            } else {
                addressInput.setCustomValidity("");
            }
        }
        // whole contact form
        if (!document.getElementById("kontaktForm").reportValidity()) {
            this.showInvalid("kontaktFormMessage", "Spávne vyplňte kontaktný formulár");
            return;
        }
        let stavbaData = this.getStep(7).data.formData.stavba;
        let kontaktData = this.getStep(7).data.formData.kontakt;
        if (kontaktData.typZadavatele === "Obchodník" && (!kontaktData.okres || kontaktData.okres === "??")) {
            this.showInvalid("regions",
                "Nie je vybraný okres, vyberte najbližší okres zo zoznamu")
            return;
        }
        if ((stavbaData.ulice == "" || stavbaData.obec == "" || stavbaData.psc == "") &&
            !(kontaktData.typZadavatele === "Realizační firma / pokrývač" || kontaktData.typZadavatele === "Obchodník")
        ) {
            this.showInvalid("buildingAddress",
                "Nesprávne zadaná adresa, vyberte platnú adresu stavby \n (vyberte stavbu na mape)")
            return;
        }
        if (stavbaData.ulice.length > 200) {
            this.showInvalid("stavbaUlice",
                "Veľmi dlhá adresa (" + stavbaData.ulice.length + " znakov). Skráťte na 200 alebo napíšte adresu do poznámky.")
            return;
        }

        // gdpr consent
        if (!this.state.gdprConsent) {
            this.showInvalid("consentSwitch", "Pre odoslanie musíte súhlasiť so spracovaním osobných údajov")
            return;
        }

        this.fillDotaznik();
    }

    getStep(num) {
        return this.state.steps.find(step => step.number == num);
    }

    showInvalid(elementId, message) {
        let element = document.getElementById(elementId);
        if (element != undefined) {
            element.setCustomValidity(message);
            element.reportValidity();
            element.setCustomValidity("");
        }
        //else // Commented "else" = always show additional validationMesage
        {
            element = document.getElementById('validationMesage');
            let existingTextElement = document.getElementById('validationText')
            if (existingTextElement != undefined) {
                element.removeChild(existingTextElement);
            }
            let textElement = document.createElement('p');
            textElement.id = 'validationText';
            textElement.innerText = message;
            element.classList.remove('d-none');
            element.appendChild(textElement);
            setTimeout(() => {
                this.hideInvalid();
            }, 4500);
        }
    }
    hideInvalid() {
        let element = document.getElementById('validationMesage');
        element.classList.add('d-none');
        let validationText = document.getElementById('validationText')
        if (validationText) element.removeChild(validationText);
    }
    debugDiv() {
        return (process.env.REACT_APP_ENV === "dev" || process.env.REACT_APP_ENV === "localhost") ? (
            <div>
                React env - {process.env.NODE_ENV};
                Custom env - {process.env.REACT_APP_ENV};
                apiUrl - {process.env.REACT_APP_API_URL};
                (Toto je viditeľné len pri testovaní)
            </div>
        ) : (<span></span>);
    }

    render() {
        this.stepsControl();
        const docUploadClass = (this.state.documentation) ? '' : 'd-none';

        return (
            <div className="App">
                <Login />
                {this.debugDiv()}

                <div key='InitialStep' className='mt-4 rootContainer m-auto'>
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol size='12' md='8' lg='9' className=''>
                                <h2 className='text-uppercase c-primary'>KALKULÁCIA STREŠNEJ KRYTINY BRAMAC</h2>
                            </MDBCol>
                            <MDBCol size='12' md='4' lg='3' className='d-flex justify-content-md-end'>
                                <MDBBtn color='link' rippleColor='light' size='lg' href={this.state.config.LINK_CENIK} className='text-decoration-underline c-primary px-0' target='_blank'>
                                    Cenník na stiahnutie
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>

                    <MDBContainer className='mb-5 planeBackground' style={{
                        backgroundImage: "url(" + BG_IMG_PLANE + "),url(" + BG_IMG_CLOUDS + ")"
                    }}>
                        <MDBRow>
                            <MDBCol size='6' className="mt-5">
                                <p>
                                    Chcete pomôcť s vyplnením? Kontaktujte nás.
                                </p>
                                <MDBBtn color='link' rippleColor='light' size='lg' className='text-decoration-underline p-0 c-primary'
                                    href={this.state.config.LINK_OBLASTNI_ZASTUPCE} target='_blank'>
                                    KONTAKT NA OBCHODNÉHO ZÁSTUPCU
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-5">
                            <MDBRow className='mt-3 align-items-end'>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.roofCalculation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={(e) => { document.getElementById('RoofCalculation').click(); }}>
                                        CHCEM SPRACOVAŤ CENOVÚ PONUKU NA ŠKRIDLU
                                    </p>
                                    <MDBValidationItem className='' invalid feedback='Example invalid feedback text.'>
                                        <MDBSwitch id='RoofCalculation' name='roofCalculation'
                                            wrapperClass="d-grid justify-content-center" defaultChecked={this.state.roofCalculation}
                                            onClick={(e) => { this.setState({ roofCalculation: e.target.checked }) }} />
                                    </MDBValidationItem>
                                </MDBCol>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.isolation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={(e) => { document.getElementById('Isolation').click(); }}>
                                        Nadkrokvová izolácia Therm a rozpis prvkov
                                    </p>
                                    <MDBSwitch id='Isolation' name='isolation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.isolation}
                                        onClick={(e) => {
                                            this.setState({ isolation: e.target.checked },
                                                this.accordionHandler(6))
                                        }} />
                                </MDBCol>
                            </MDBRow>

                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol xl="11" md='11' sm="12">
                                <p>
                                    Máte projektovú dokumentáciu? Tzn. pôdorys strechy alebo krovu so zakreslenými sklonmi (môže byť aj náčrtok,nákres apod.),
                                    príp. rezy a pohľady. Nemáte dokumentáciu? Nevadí, rozmery strechy získame pomocou leteckého zamerania.
                                </p>
                            </MDBCol>
                            <MDBRow className='mt-3'>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.documentation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={() => { document.getElementById('HaveDocumentation').click(); }}>
                                        MÁM PROJEKTOVÚ DOKUMENTÁCIU
                                    </p>
                                    <MDBSwitch id='HaveDocumentation' name='documentation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.documentation}
                                        onClick={(e) => {
                                            this.setState(
                                                { documentation: e.target.checked },
                                                () => this.handleDocumentation(e))
                                        }} />
                                </MDBCol>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.noDocumentation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={() => { document.getElementById('DontHaveDocumentation').click(); }}>
                                        NEMÁM PROJEKTOVÚ DOKUMENTÁCIU - Letecké zameranie
                                    </p>
                                    <MDBSwitch id='DontHaveDocumentation' name='documentation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.noDocumentation}
                                        onClick={(e) => {
                                            this.setState({ noDocumentation: e.target.checked },
                                                () => {
                                                    this.toggleNoDocModal();
                                                    this.handleDocumentation(e);
                                                })
                                        }} />
                                </MDBCol>
                            </MDBRow>

                            <div key='NoDocumentationModals'>
                                <MDBModal staticBackdrop open={this.state.noDocumentationModal} tabIndex='-1'>
                                    <MDBModalDialog centered size='lg'>
                                        <MDBModalContent className='p-2'>
                                            <MDBModalHeader>
                                                <MDBModalTitle className='text-uppercase'>ZAMERANIE STRECHY BEZ DOMUNETÁCIE</MDBModalTitle>
                                                {/*<MDBBtn className='btn-close' color='none' onClick={() => this.toggleNoDocModal()}></MDBBtn>*/}
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                                <p>
                                                    Rozpis materiálu a cenovú ponuku spracovávame na základe leteckých snímkov, z ktorých získame zameranie strechy.
                                                </p>
                                                <p>
                                                    Kalkuláciu bez dodanej projektovej dokumentácie môžeme teda spracovať
                                                    <b> iba pre existujúce objekty.</b>
                                                </p>
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn color='primary' className='mx-auto fs-6 px-5 no-doc-modal-btn' onClick={() => this.setState({ buildingExists: true }, this.toggleNoDocModal())}>
                                                    ANO, JEDNÁ SE O UŽ EXISTUJÚCÍ OBJEKT
                                                </MDBBtn>
                                                <MDBBtn color='primary' className='mx-auto fs-6 px-5 no-doc-modal-btn' onClick={() => { this.toggleNoDocModal(); this.toggleNoBuildingModal(); }}>
                                                    NIE, OBJEKT SA BUDE EŠTE LEN STAVAŤ
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </MDBModalContent>
                                    </MDBModalDialog>
                                </MDBModal>
                                <MDBModal staticBackdrop open={this.state.noBuildingModal} tabIndex='-1'>
                                    <MDBModalDialog centered>
                                        <MDBModalContent>
                                            <MDBModalHeader>
                                                <MDBModalTitle className='text-uppercase'>Pozor!</MDBModalTitle>
                                                <MDBBtn className='btn-close' color='none' onClick={() => {
                                                    this.toggleNoBuildingModal();
                                                    document.getElementById('DontHaveDocumentation').click();
                                                }}></MDBBtn>
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                                U neexistujúcich objektov bez dokumentácie nemôžeme spracovať cenovú ponuku.
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn color='primary' className='mx-auto fs-6' onClick={() => {
                                                    this.toggleNoBuildingModal();
                                                    document.getElementById('DontHaveDocumentation').click();
                                                }}>
                                                    ROZUMIEM
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </MDBModalContent>
                                    </MDBModalDialog>
                                </MDBModal>
                            </div>
                        </MDBRow>
                    </MDBContainer>

                    <MDBContainer className={docUploadClass}>
                        <Step key={"step2"} step={this.state.steps.find(step => step.number == 2)} handler={this.stepsHandler} />
                    </MDBContainer>

                    <MDBContainer>
                        <MDBAccordion flush alwaysOpen active={this.state.activeItems} onChange={(itemId) => this.accordionHandler(itemId)}>
                            {this.state.steps.map(step => {
                                return (step.accStep) ? (
                                    <MDBAccordionItem collapseId={step.number} headerTitle={step.header} key={'step' + step.number} className={step.visibleClass}>
                                        <MDBContainer>
                                            <Step step={step} handler={this.stepsHandler} stateHandler={this.stateHandler} selectedCoveringColor={this.state.selectedCoveringColor} />
                                        </MDBContainer>
                                    </MDBAccordionItem>
                                ) : (
                                    <div key={"nstep" + step.number}></div>
                                )

                            })}
                        </MDBAccordion>
                    </MDBContainer>

                    <MDBContainer className='mt-5 d-flex justify-content-center align-items-center'>
                        <MDBSwitch id='consentSwitch' name='consent'
                            onClick={(e) => { this.setState({ gdprConsent: e.target.checked }) }} />
                        <MDBBtn color='link' rippleColor='light' className='content-link ms-1 px-1' onClick={() => { this.setState({ gdprModal: true }) }}>
                            SÚHLAS SO SPRACOVANÍM OSOBNÝCH ÚDAJOV A POUČENIE SUBJEKTU ÚDAJOV
                        </MDBBtn>

                        <MDBModal open={this.state.gdprModal} tabIndex='-1' onClose={() => this.setState({ gdprModal: false })}>
                            <MDBModalDialog scrollable size='xl'>
                                <MDBModalContent className='p-2'>
                                    <MDBModalHeader>
                                        <MDBModalTitle className='text-uppercase'>Spracovanie osobných údajov a poučenie subjektu údajov</MDBModalTitle>
                                        <MDBBtn className='btn-close' color='none' onClick={() => this.setState({ gdprModal: false })}></MDBBtn>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <Step step={this.state.steps.find(step => step.number == 8)} handler={this.stepsHandler} stateHandler={this.stateHandler} />
                                    </MDBModalBody>
                                    <MDBModalFooter>
                                        <MDBBtn color='primary' className='mx-auto fs-6' onClick={() => this.setState({ gdprModal: false })}>
                                            ROZUMIEM
                                        </MDBBtn>
                                    </MDBModalFooter>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </MDBContainer>

                    <MDBContainer className="d-grid my-4 text-center">
                        <div id='validationMesage' className='validation-msg d-none fs-5' onClick={() => this.hideInvalid()}>
                            <MDBBtn className='btn-close float-end ms-3' color='none'></MDBBtn>
                        </div>
                        <button id='sendFormBtn' className="btn btn-primary btn-lg fs-5 fw-bold"
                            onClick={() => this.validateAll()} disabled={!this.state.gdprConsent}>
                            ODOSLAŤ &gt;&gt;
                        </button>
                        <MDBModal staticBackdrop open={this.state.loadingModal} tabIndex='-1' >
                            <MDBModalDialog centered>
                                <MDBModalContent className='p-2'>
                                    <MDBModalHeader>
                                        <MDBModalTitle className='text-uppercase'>{this.state.loadingModalTitle}</MDBModalTitle>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <p>{this.state.loadingModalText}</p>
                                    </MDBModalBody>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </MDBContainer>

                </div>
                {this.sendDotaznik()}

                <BmiCookieConsent />
            </div>
        );
    }
}

export default PriceCalculatorForm;


function primaryColorByBool(value) {
    return value ? ' c-primary ' : ' ';
}


